import { FormField, PubSub, StateManager, CssModifiers, ScrollTo } from '../../utils'

let $part2 = null
let $cardMachine = null
let $paymentGateway = null
let $part3 = null
let $ntc = null
let $switcher = null
let $part4 = null
let $cardMachineDropdowns = null
let _state = undefined

const PRODUCT_TYPE = {
  PAYMENT_GATEWAY: 'PaymentGateway',
  CARD_MACHINE: 'CardMachine'
}

const NEW_TO_CARDS = {
  YES: 'False',
  NO: 'True'
}

const FIELD_NAME = {
  PRODUCT_TYPE: 'Form.ProductType',
  PROCESS_CARD_PAYMENTS: 'Form.ProcessCardPayments'
}

const STATE_ATTR = 'data-state-toggle'
const STATE_ID = 'quote'

const init = () => {
  // TODO: Abstract file into isolation
  if (window.isQuotePage == undefined) return

  $part2 = document.querySelector(`[${STATE_ATTR}='part2']`)
  $cardMachine = [...document.querySelectorAll(`[${STATE_ATTR}='cardMachine']`)]
  $paymentGateway = [...document.querySelectorAll(`[${STATE_ATTR}='paymentGateway']`)]
  $part3 = document.querySelector(`[${STATE_ATTR}='part3']`)
  $ntc = [...document.querySelectorAll(`[${STATE_ATTR}='ntc']`)]
  $switcher = [...document.querySelectorAll(`[${STATE_ATTR}='switcher']`)]
  $part4 = document.querySelector(`[${STATE_ATTR}='part4']`)
  $cardMachineDropdowns = [...document.querySelectorAll('.ps-styled-dropdown select')]

  const $productTypeCheck = document.querySelector(`input[name="${FIELD_NAME.PRODUCT_TYPE}"]:checked`)
  const $clientTypeCheck = document.querySelector(`input[name="${FIELD_NAME.PROCESS_CARD_PAYMENTS}"]:checked`)

  let productTypeValue = undefined
  let clientTypeValue = undefined

  if ($productTypeCheck != null) productTypeValue = $productTypeCheck.value
  if ($clientTypeCheck != null) clientTypeValue = $clientTypeCheck.value

  _state = StateManager(STATE_ID, {
    productType: {
      cardMachine: /cardmachine/i.test(productTypeValue),
      paymentGateway: /paymentgateway/i.test(productTypeValue)
    },

    clientType: {
      ntc: /false/i.test(clientTypeValue),
      switcher: /true/i.test(clientTypeValue)
    }
  })

  updateView()
  addEventListeners()
}


const onChange = e => {
  const $el = e.target
  const formField = FormField($el)
  const { typeIs, valueOf } = formField

  if (typeIs.select() && /Form\.[a-z]+Quantity/i.test($el.name)) {
    const $parent = getParentNode($el, 'ps-product-card')
    CssModifiers[$el.value ? 'add' : 'remove']($parent, 'm-active')
  }

  if (typeIs.radioGroup() && $el.name == FIELD_NAME.PRODUCT_TYPE) {
    _state.set('productType', {
      cardMachine: valueOf.radioGroup() == PRODUCT_TYPE.CARD_MACHINE,
      paymentGateway: valueOf.radioGroup() == PRODUCT_TYPE.PAYMENT_GATEWAY
    })
  }

  if (typeIs.radioGroup() && $el.name == FIELD_NAME.PROCESS_CARD_PAYMENTS) {
    _state.set('clientType', {
      ntc: valueOf.radioGroup() == NEW_TO_CARDS.YES,
      switcher: valueOf.radioGroup() == NEW_TO_CARDS.NO
    })

    window.setTimeout(() => {
      ScrollTo('#ps-predicted-revenue')
    }, 0)
  }

}


const getParentNode = ($el, className) => {
  return $el.parentNode.classList.contains(className)
    ? $el.parentNode
    : getParentNode($el.parentNode, className)
}

const updateView = data => {
  if (data != undefined && data.stateId != STATE_ID) return

  const state = _state.get()

  const { cardMachine, paymentGateway } = state.productType
  const { ntc, switcher } = state.clientType

  $part2.style.display = cardMachine || paymentGateway ? 'inherit' : 'none'
  $cardMachine.forEach($el => $el.style.display = cardMachine ? 'inherit' : 'none')
  $paymentGateway.forEach($el => $el.style.display = paymentGateway ? 'inherit' : 'none')
  $part3.style.display = ntc || switcher ? 'inherit' : 'none'
  $ntc.forEach($el => $el.style.display = ntc ? 'inherit' : 'none')
  $switcher.forEach($el => $el.style.display = switcher ? 'inherit' : 'none')
  $part4.style.display = ntc || switcher ? 'inherit' : 'none'
  $cardMachineDropdowns.forEach($el => {
    if ($el.selectedIndex) {
      const $parent = getParentNode($el, 'ps-product-card')
      CssModifiers.add($parent, 'm-active')
    }
  })
}


const addEventListeners = () => {
  const $form = document.querySelector('form')

  $form.addEventListener('change', onChange)
  PubSub.subscribe('state:change', updateView)
}

const QuoteInteractionHandler = { init }
export default QuoteInteractionHandler



// WEBPACK FOOTER //
// ./js/self-serve/core/QuoteInteractionHandler.js